// The Shipping hub's place in the URL: /shipping-queue?tab=ready&so=1147&pallet=508. A reload or a shared link
// opens the same tab (and the same order's package guide on the same pallet). The page renders without a router
// in its tests, so this reads and writes window.location / history directly.

export const HUB_TABS = Object.freeze([
  { id: 'pack', label: 'Pack', lane: true },
  { id: 'ready', label: 'Ready to ship', lane: true },
  { id: 'pickup', label: 'Ready for pickup', lane: true },
  { id: 'out', label: 'Out for delivery', lane: true },
  { id: 'outsourcing', label: 'Outsourcing' },
  { id: 'byjob', label: 'Ship by job' },
  { id: 'history', label: 'History' },
]);

export const DEFAULT_TAB = 'pack';
const TAB_IDS = new Set(HUB_TABS.map((t) => t.id));

const posInt = (v) => {
  const n = parseInt(v, 10);
  return Number.isInteger(n) && n > 0 && String(n) === String(v).trim() ? n : null;
};

/** ?tab=&so=&pallet= -> {tab, so, pallet}; an unknown tab is the default; so / pallet are positive ids or null. */
export function readHubUrl(search) {
  const p = new URLSearchParams(search || '');
  const tab = TAB_IDS.has(p.get('tab')) ? p.get('tab') : DEFAULT_TAB;
  const so = posInt(p.get('so'));
  return { tab, so, pallet: so ? posInt(p.get('pallet')) : null };
}

/** The query string for a hub place, keeping any other parameter already there. */
export function hubSearch({ tab, so = null, pallet = null }, current = '') {
  const p = new URLSearchParams(current || '');
  p.set('tab', TAB_IDS.has(tab) ? tab : DEFAULT_TAB);
  if (so) p.set('so', String(so)); else p.delete('so');
  if (so && pallet) p.set('pallet', String(pallet)); else p.delete('pallet');
  return `?${p.toString()}`;
}

/** Put a hub place in the address bar: push (Back returns) or replace. */
export function writeHubUrl(place, { push = false } = {}) {
  try {
    const next = `${window.location.pathname}${hubSearch(place, window.location.search)}${window.location.hash || ''}`;
    if (next === `${window.location.pathname}${window.location.search}${window.location.hash || ''}`) return;
    if (push) window.history.pushState(window.history.state, '', next);
    else window.history.replaceState(window.history.state, '', next);
  } catch (_) {
    // no history (never in the app)
  }
}
